import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import Home from './components/page/Home';
import Download from './components/page/Download';
import Calendar from './components/calendar/Calendar';

function App() {
  return (
    <BrowserRouter>
      <Switch>
          <Route exact path='/' component={Home} />
          <Route path='/download/:id' component={Download} />
          <Route path='/calendar/:id' component={Calendar} />
      </Switch>
    </BrowserRouter>
  );
}

export default App;
